import React, { useState, useEffect } from "react";
import Select from "react-select";
// import airports from "../data/airports"; // By Airport hidden
// airlines / flightNumbers imports removed (not used in this component)
import TermsModal from "./TermsModal"; // Your reusable modal
// calculation is handled in the parent (HomePage). No direct import here.
import "./CalculatorForm.css";
import myImage from "../assets/foot.png";
// Parent handles navigation and report sending
import Stepper from "./Stepper";

const cabinOptions = [
  { value: "economy", label: "Economy" },
  { value: "premiumEconomy", label: "Premium Economy" },
  { value: "business", label: "Business Class" },
  { value: "first", label: "First Class" },
];

const tripOptions = [
  { value: "One Way", label: "One Way" },
  { value: "Round Trip", label: "Round Trip" },
];

function CalculatorForm({
  departure,
  setDeparture,
  arrival,
  setArrival,
  passengers,
  setPassengers,
  cabinClass,
  setCabinClass,
  tripType,
  setTripType,
  operatingCarrierCode,
  setOperatingCarrierCode,
  flightNumber,
  setFlightNumber,
  departureDate,
  setDepartureDate,
  email,
  setEmail,
  isDisabled = false,
  handleCalculate,
  isTermsAccepted,
  setTermsAccepted,
  setError,
  setEmissions,
  flyingHours,
  setFlyingHours,
  calculationMode,
  setCalculationMode,
  currentStep,
  setCurrentStep,
}) {
  // const [airportOptions] = useState(airports); // By Airport hidden
  // carrier/flight options are available via imports if needed, not held in state
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Ensure the form always operates in "hours" mode while the
  // By Airport UI is hidden. This makes the Flying Hours option the
  // active calculation mode regardless of parent state.
  useEffect(() => {
    if (setCalculationMode) setCalculationMode("hours");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // result/report state moved to parent
  const [isLoading, setIsLoading] = useState(false); // loader state

  // Navigation is handled by parent; no local navigate needed

  // Passenger input handler
  const handlePassengerChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 1 && value <= 100) setPassengers(value);
  };

  // Date validation is performed by parent; we keep a simple setter call in input

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const handleTermsAccept = () => {
    setTermsAccepted(true);
    closeModal();
  };
  const handleTermsClick = () => {
    if (!isTermsAccepted) openModal();
    else setTermsAccepted(false);
  };

  // Calculate button click handler
  const handleCalculateClick = async () => {
    if (!isTermsAccepted) return openModal();

    setCurrentStep(2);
    setIsLoading(true); // start loader

    try {
      let res = null;

      // Delegate calculation to parent for both modes.
      // HomePage.handleCalculate will perform validation, call backend,
      // and navigate to the appropriate result route (/result or /result/hours).
      res = await handleCalculate();
      console.log("← Received handleCalculate response:", res);

      // If the parent already navigated (it should for both modes),
      // just stop loading and allow the parent navigation to proceed.
      if (res && res.__alreadyNavigated) {
        setIsLoading(false);
        return;
      }

      if (res) {
        // pass result to parent so it can display/track emissions
        setEmissions && setEmissions(res);
        setCurrentStep(3);
      }
    } catch (err) {
      console.error("Calculation failed:", err);
      setError(err.message || "Calculation failed. Check server/console.");
      alert("Calculation failed. See console/network for details.");
    } finally {
      setIsLoading(false); // stop loader
    }
  };

  // send report handled by a parent/service; removed local handler to avoid unused var

  return (
    <>
      <div className="container ">
        <div className="row">
          <Stepper currentStep={1} />

          <h2
            className="fw-bold text-center py-4"
            style={{
              color: "#063970",
              fontWeight: "bold",
              fontFamily: "Oswald, sans-serif",
            }}
          >
            Flight Emissions Calculator
          </h2>
          <p className="text-center">
            Calculate your flight carbon footprint and explore offset options
          </p>

          {/* Left Form Section */}
          <div className="col-lg-8 col-md-7 col-sm-12 mt-3">
            <div className="form-box p-4 shadow-sm rounded bg-white">
              {/* Mode Selection - By Airport hidden (preserved in comments)
              <div className="mb-3">
                <label className="form-label fw-bold">
                  Select Calculation Mode:
                </label>
                <div className="d-flex align-items-center gap-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="calculationMode"
                      checked={calculationMode === "airport"}
                      onChange={() => {
                        setCalculationMode("airport");
                        setEmissions();
                        setError();
                        // clear any previous emissions in parent
                        setEmissions && setEmissions(null);
                        setCurrentStep(1);
                      }}
                    />
                    <label className="form-check-label">By Airport</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="calculationMode"
                      checked={calculationMode === "hours"}
                      onChange={() => {
                        setCalculationMode("hours");
                        setEmissions();
                        setError();
                        // clear any previous emissions in parent
                        setEmissions && setEmissions(null);
                        setCurrentStep(1);
                      }}
                    />
                    <label className="form-check-label">By Flying Hours</label>
                  </div>
                </div>
              </div>
              */}
              <div className="mb-3">
                <label className="form-label fw-bold">Calculation Mode:</label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="calculationMode"
                    checked={true}
                    disabled
                    readOnly
                  />
                  <label className="form-check-label">By Flying Hours</label>
                </div>
              </div>
              {/* <label className="form-check-label">By Flying Hours</label> */}
              {/* Note: show Flying Hours guidance only */}
              <div className="warning-box mt-2">
                <strong>By Flying Hours:</strong> You can directly estimate
                emissions based on total flying hours. Example: 2.5 = 2 hours 30
                minutes.
              </div>

              {/* Flying Hours input (Airport fields hidden and preserved in comments)
              {calculationMode === "airport" && (
                <>
                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      Departure Airport:
                    </label>
                    <Select
                      isDisabled={isDisabled}
                      value={
                        airportOptions.find((o) => o.value === departure) ||
                        null
                      }
                      options={airportOptions}
                      onChange={(option) => setDeparture(option.value)}
                      placeholder="Select departure airport..."
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      Arrival Airport:
                    </label>
                    <Select
                      isDisabled={isDisabled}
                      value={
                        airportOptions.find((o) => o.value === arrival) || null
                      }
                      options={airportOptions}
                      onChange={(option) => setArrival(option.value)}
                      placeholder="Select arrival airport..."
                    />
                  </div>
                </>
              )}
              */}
              <div className="mb-3">
                <label className="form-label fw-bold">Flying Hours:</label>
                <input
                  disabled={isDisabled}
                  type="number"
                  className="form-control"
                  value={flyingHours}
                  onChange={(e) =>
                    setFlyingHours(
                      e.target.value === "" ? "" : Number(e.target.value)
                    )
                  }
                  placeholder="Enter flying hours"
                  min="0.1"
                  step="0.1"
                />
                <div className="form-text">
                  Example: 2.5 for 2 hours 30 minutes
                </div>
              </div>

              {/* Row for Passengers, Cabin, Trip */}
              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="form-label fw-bold">
                    Number of Passengers:
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={passengers}
                    onChange={handlePassengerChange}
                    min="1"
                    max="100"
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label fw-bold">Cabin Class:</label>
                  <Select
                    value={
                      cabinOptions.find((o) => o.value === cabinClass) || null
                    }
                    options={cabinOptions}
                    onChange={(option) => setCabinClass(option.value)}
                    disabled={isDisabled}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label fw-bold">Trip Type:</label>
                  <Select
                    value={
                      tripOptions.find((o) => o.value === tripType) || null
                    }
                    options={tripOptions}
                    onChange={(option) => setTripType(option.value)}
                    disabled={isDisabled}
                  />
                </div>
              </div>

              {/* Email */}
              <div className="mb-3">
                <label className="form-label fw-bold">Email Address:</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isDisabled}
                />
              </div>

              {/* Terms */}
              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={isTermsAccepted}
                  onChange={handleTermsClick}
                  disabled={isDisabled}
                />
                <label className="form-check-label">
                  I accept the terms and conditions
                </label>
              </div>

              {/* Calculate Button with Loader */}
              <div className="d-flex flex-column justify-content-center align-items-center mt-3">
                <button
                  className="cal-btn"
                  onClick={handleCalculateClick}
                  disabled={isDisabled || isLoading}
                >
                  Calculate Emissions
                </button>

                {isLoading && (
                  <div className="mt-2 text-muted">⏳ Calculating…</div>
                )}
              </div>

              {/* Terms Modal */}
              <TermsModal
                isOpen={isModalOpen}
                onClose={closeModal}
                onAccept={handleTermsAccept}
              />
            </div>
          </div>

          {/* Right Aside Section */}
          <aside className="col-lg-4 col-md-5 col-sm-12 mt-3 d-none d-md-block">
            <div className="card p-3 mb-3">
              <h5
                style={{
                  color: "#063970",
                  fontWeight: "bold",
                  fontFamily: "Oswald, sans-serif",
                }}
              >
                Reduce your footprint
              </h5>
              <ul className="custom-list">
                <li>Fly economy</li>
                <li>Choose direct flights when possible</li>
                <li>Pack light to reduce aircraft weight</li>
                <li>Choose airlines using sustainable fuel</li>
                <li>Consider train travel for short distances</li>
                <li>Offset remaining emissions responsibly</li>
              </ul>
            </div>

            <div className="card p-3">
              <img src={myImage} alt="cargo" className="img-fluid rounded" />
            </div>
          </aside>
        </div>
      </div>
    </>
  );
}

export default CalculatorForm;
